import { Button, CollaboratorWithTooltipGroup } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import certificateImg from 'src/images/pngs/learningpathcert.png';
import { sanitizeAndRenderHtmlString } from 'src/common/helpers';
import { PathOutlineRooms } from 'src/features/path-outline/components/path-outline-rooms/path-outline-rooms';
import { SocSimAdBanner } from 'src/common/components';
import sal1Image from 'src/images/pngs/certifications/sal1-card.png';
import { useSegmentTracking } from 'src/common/hooks/use-segment-tracking';
import { StyledCardImage, StyledCardContent, StyledColumnLeft, StyledContainer, StyledOuter, StyledCardWithImage, StyledSectionNumber, StyledSectionTitle, StyledDescription, StyledCertImage, StyledSectionTitleRow, StyledGrid, StyledSal1Card, StyledCertCard, StyledCertCardImage } from './path-outline-main-content.styles';
import { PathOutlineMainContentProps } from './path-outline-main-content.types';
export const PathOutlineMainContent: React.FC<PathOutlineMainContentProps> = ({
  title,
  banner,
  intro,
  description,
  modules,
  showSocSimAd,
  showSal1Ad,
  isRetired
}) => {
  const navigate = useNavigate();
  const {
    triggerButtonClickEvent
  } = useSegmentTracking();
  const handleLearnMore = () => {
    triggerButtonClickEvent('sal1-ad-click', 'certification-socl1-path-ad', 'learn-more');
    navigate('/certification/security-analyst-level-1');
  };
  return <StyledOuter data-sentry-element="StyledOuter" data-sentry-component="PathOutlineMainContent" data-sentry-source-file="path-outline-main-content.tsx">
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="path-outline-main-content.tsx">
        {showSocSimAd && <SocSimAdBanner />}
        <StyledGrid data-sentry-element="StyledGrid" data-sentry-source-file="path-outline-main-content.tsx">
          <StyledColumnLeft data-sentry-element="StyledColumnLeft" data-sentry-source-file="path-outline-main-content.tsx">
            <StyledCardWithImage data-sentry-element="StyledCardWithImage" data-sentry-source-file="path-outline-main-content.tsx">
              <StyledCardImage data-testid="path-card-image" src={banner} alt={`Path ${title}`} data-sentry-element="StyledCardImage" data-sentry-source-file="path-outline-main-content.tsx" />
              <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="path-outline-main-content.tsx">{sanitizeAndRenderHtmlString(description)}</StyledDescription>
            </StyledCardWithImage>
            {showSal1Ad ? <>
                <StyledCertCard>
                  <h5>Certificate of Completion</h5>
                  <div>
                    <StyledCertCardImage data-testid="certificate-image" src={certificateImg} alt="Example learning path completion certificate" />
                    <p>
                      Complete this learning path to <br /> develop your skills and earn a <br /> certificate of
                      completion
                    </p>
                  </div>
                </StyledCertCard>
                <StyledSal1Card>
                  <StyledCertImage data-testid="sal1-image" src={sal1Image} alt="Example learning path completion certificate" />
                  <div>
                    <h5>SAL1 Professional Certification</h5>
                    <p>Get hired with an industry-recognised, practical defensive certification</p>
                    <Button variant="outlined" color="secondary" onClick={handleLearnMore}>
                      Learn more
                    </Button>
                  </div>
                </StyledSal1Card>
              </> : <StyledCardWithImage>
                <StyledCertImage data-testid="certificate-image" src={certificateImg} alt="Example learning path completion certificate" />
                <div>
                  <p>Complete this learning path and earn a certificate of completion</p>
                </div>
              </StyledCardWithImage>}
          </StyledColumnLeft>
          <StyledCardContent data-sentry-element="StyledCardContent" data-sentry-source-file="path-outline-main-content.tsx">
            <div>
              <h3>Introduction</h3>
              {sanitizeAndRenderHtmlString(intro)}
            </div>
            {modules.map(({
            title: moduleTitle,
            rooms,
            collaborators
          }, index) => {
            const compositeKey = `${moduleTitle.split(' ').join('').toLowerCase()}-${index}`;
            return <div key={compositeKey}>
                  <StyledSectionNumber>{`Section ${index + 1}`}</StyledSectionNumber>
                  <StyledSectionTitleRow className="title-row">
                    <StyledSectionTitle>{moduleTitle}</StyledSectionTitle>
                    {collaborators && collaborators.length > 0 && <CollaboratorWithTooltipGroup collaborators={collaborators} />}
                  </StyledSectionTitleRow>
                  <PathOutlineRooms rooms={rooms} isRetired={isRetired} />
                </div>;
          })}
          </StyledCardContent>
        </StyledGrid>
      </StyledContainer>
    </StyledOuter>;
};